module.exports = "/assets/image-hero@2x.jpg?c8IWgKn";